// extracted by mini-css-extract-plugin
module.exports = {"link":"ProductReviewCTA_link__2dDNa"};